import React, {Component} from 'react';
import Calendar from 'react-calendar/dist/entry.nostyle'
import PropTypes from 'prop-types';

// import {Link} from "react-router-dom";
// import Calendar from 'react-calendar'
// import icsToJson from 'ics-to-json'
import moment from 'moment'
import {Box, Button, Flex, Heading} from 'rebass';
import {CalenderWrapper, MobileHeader, DesktopBox} from "../../components/Base";
// import {MetaText} from "../../components/Base/Text";
// import testFeed from '../../resources/feed_466B5D30C4974D20A359C651D453B006.ics'
import {Circle} from "styled-spinkit";
import {HeadingWrapper, TitleSection} from './styles'
import CalendarTabs from './CalendarTabs'

import {icalData} from '../../constants/calendar'
// This page is the Calendar page for School Events (Not Wave History)
// Parses a static Ical file on load
class CalendarPage extends Component {
	state = {
		loading: false,
		date: new Date(),
		icalData: icalData,
		currentMonth: [],
		selected: [],
		memo: {}
	};

	async componentDidMount() {
		const {date} = this.props;
		// const icalData = await this.parseIcalfile();
		const selectedData = this.filterSelectedDate(icalData, date);
		const dateString = moment(date).format('MMMDD');
		const selected = {[dateString]: selectedData};
		// console.log('selected', selected);
		const currentMonth = this.getMonthDayList(icalData, date);
		this.setState({ selected: selectedData, memo: selected, currentMonth})
	}
	//
	// parseIcalfile = async () => {
	// 	// const output = ical2json.convert(require('../../resources/feed_466B5D30C4974D20A359C651D453B006.ics'))
	// 	const icsRes = await fetch(testFeed);
	// 	const icsData = await icsRes.text();
	//
	// 	const data = icsToJson(icsData);
	//
	//
	// 	return data
	// };


	// This is returns the list of iCal events for the selected date.
	filterSelectedDate = (icalData, date) => {
		const filtered = icalData.filter(event => moment(event.startDate).isSame(date, 'day'));
		// console.log('filtered', filtered)
		const selected = filtered.map(event => {
			let parsedEvent = event;
			if (event.startDate) {
				parsedEvent.startDate = moment(event.startDate).format("h:mm a");
				if (parsedEvent.startDate === 'Invalid date') {
					parsedEvent.startDate = moment.utc().seconds(event.startDate).format("h:mm a")
				}
			}
			if (event.endDate) {
				parsedEvent.endDate = moment(event.endDate).format("h:mm a");
				if (parsedEvent.endDate === 'Invalid date') {
					parsedEvent.endDate = moment.utc().seconds(event.endDate).format("h:mm a")
				}
			}
			return parsedEvent
		});
		// console.log('selected', selected)
		return selected;
	};

	// This handles changing the date in the calendar
	onChange = date => {
		const {updateDate} = this.props;
		const {icalData, currentMonth, memo} = this.state;
		let newSelectedData;
		let newMemo = memo;
		if (memo[moment(date).format('MMMDD')]) {
			newSelectedData = memo[moment(date).format('MMMDD')]
		} else {
			newSelectedData = this.filterSelectedDate(icalData, date);
			const dateString = moment(date).format('MMMDD');
			newMemo = {...memo, [dateString]: newSelectedData}
		}
		let month = currentMonth;
		if (!moment(date).isSame(this.state.date, 'month')) {
			month = this.getMonthDayList(icalData, date)
		}
		updateDate(date)
		this.setState({date, selected: newSelectedData, currentMonth: month, memo: newMemo})
	};


	// Returns list of days that have events
	// todo: update calendar tiles to show something is there
	getMonthDayList = (icalData, date) => {
		const days = icalData.filter(event => moment(event.startDate).isSame(date, 'month')).map(event => {
			// console.log(event.startDate)
			let parsedDate = moment(event.startDate);
			// console.log(parsedDate)
			if (!parsedDate.isValid()) {
				parsedDate = moment.utc().seconds(event.startDate)
			}
			return parsedDate.format('D')


		});
		return days
	};


	// For Calendar to apply classnames to tiles
	handleTileClassNames = ({date, view}) => {
		const {currentMonth} = this.state;
		if (view === 'month' && currentMonth.includes(moment(date).format("D"))) {
			console.log(true);
			return 'has-event'
		}
		return null
	};

	flashLoadingCircle = () => {
		this.setState({loading: true})
		setTimeout(() => {
			this.setState({loading: false})
		}, 200)
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if(nextProps.date !== this.props.date){
			this.flashLoadingCircle()
		}
	}

	goToManageCalendar = () => {
		const date = moment(this.props.date).format('YYYY-MM-DD');
		this.props.updateSelectedDate(date);
		this.props.history.push('/app/calendar/manage');
	};

	render() {
		const {selected, loading} = this.state;
		const {date, categories, tothSchedule} = this.props;
		const {isFaculty} = this.props;
		const dateString = moment(date).format("dddd, MMM Do");
		const formattedDate = moment(date).format('YYYY-MM-DD');
		const today = moment().format('YYYY-MM-DD');
		const isSameOrAfter = moment(formattedDate).isSameOrAfter(today);
		return (
			<Box>
				<Box>
					<MobileHeader bg={'#263039'} boxShadow={'none'}>
						<Heading ml={1} pt={2} color={'white'}>Calendar</Heading>
					</MobileHeader>
					<CalenderWrapper bg={'#263039'} color={'white'} width={1}>
						<Calendar
							onChange={this.onChange}
							value={date}
							tileClassName={this.handleTileClassNames}
						/>
					</CalenderWrapper>
				</Box>
				<Box>

					<Flex flexWrap={'wrap'} direction={'column'}>
						<TitleSection>
							<Flex justifyContent={'space-between'} flexWrap={'wrap'} flexDirection={'row'}>
								<HeadingWrapper flexDirection={'column'} justifyContent={'center'} flexWrap={'wrap'}>
									<Heading as={'h4'} m={0} lineHeight={0}>{dateString}</Heading>
								</HeadingWrapper>
								<Flex flexDirection={'column'} flexWrap={'wrap'} justifyContent={'center'}>
									{isFaculty &&
									<DesktopBox>
										{ isSameOrAfter && (
											<Button onClick={this.goToManageCalendar} variant={'mainLong'} bg={'blue'} m={1}>Manage Calendar</Button>
										)}
									</DesktopBox>}
								</Flex>
							</Flex>
						</TitleSection>
						{/*<Box width={1} p={3}>*/}
						{/*	{selected.map((event, x) =>*/}
						{/*		<Flex flexWrap={'wrap'} justifyContent={'center'} py={2} key={x}>*/}
						{/*			<Box width={1}><Text textAlign={'center'}>{event.location || event.description || event.summary}</Text></Box>*/}
						{/*			<Box width={1}>*/}
						{/*				<MetaText textAlign={'center'}>{event.startDate} {event.endDate && `- ${event.endDate}`}</MetaText>*/}
						{/*			</Box>*/}
						{/*		</Flex>*/}
						{/*	)}*/}

						{/*</Box>*/}


						{loading ? <Flex flexWrap={'wrap'} flexDirection={'column'} width={1} alignItems={'center'} justifyContent={'center'} ><Circle/></Flex> :
							<CalendarTabs
								schoolSchedule={selected}
								categories={categories}
								tothSchedule={tothSchedule}
								tothData={this.props.tothData}
								formattedDate={formattedDate}
							/>
						}
					</Flex>
				</Box>
			</Box>
		)
	}
}

CalendarPage.propTypes = {
	categories: PropTypes.array,
	updateDate: PropTypes.func,
	tothSchedule: PropTypes.array
};

CalendarPage.defaultProps = {
	categories: [],
	tothSchedule: [],
	updateDate: (date) => console.log(date)
};

export default CalendarPage
